const handleOpenFullScreen = function(payload: boolean){

    let root = document.getElementById("root")

    if(payload === false){
        if (root && root.requestFullscreen) {
            root.requestFullscreen();
        }
    }
    else{
        document.exitFullscreen()
    }
}

export default handleOpenFullScreen